<template>
  <div class="results-operation flex-box">
    <div class="title">{{ descInfo.title }}</div>
   
    <div class="results-content">
      <div class="desc1">
        <div v-for="(item, k) in descInfo.descArr1" :key="k">{{ item }}</div>
      </div>
      <div class="desc2" v-if="descInfo.descArr2 && descInfo.descArr2.length">
        <div v-for="(item, k) in descInfo.descArr2" :key="k">{{ item }}</div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    descInfo: {
      type: Object,
      default: () => {
        return {
          title: '',
          descArr1: [],
          descArr2: []
        }
      }
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.results-operation {
  padding: 9rem 26rem 7rem;
  flex-direction: column;
  align-items: center;
  background-color: #FFFFFF;

  .title {
    font-size: 4rem;
    font-weight: 600;
    color: #333333;
    line-height: 4rem;
    margin-bottom: 2.4rem;
  }

  .results-content {
    display: flex;
    width: 100%;
    .desc1 {
      background: #F4F9FF;
    }
    .desc2, .desc1 {
      flex: 1;
      padding: 3rem 4rem;
      div {
        color: #333333;
        font-size: 2.2rem;
        line-height: 3.6rem;
        margin-bottom: 1rem;
        &::before {
          content: '◇ '
        }
      }
    }
    
  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .results-operation {
    padding: 4.8rem 1.6rem;
    .title {
      font-size: 2.4rem;
      line-height: 3.2rem;
      text-align: center;
    }
    .results-content {
      flex-wrap: wrap;
      .desc1,
      .desc2 {
        flex: none;
        width: 100%;
        padding: 2rem 1.6rem;
        div {
          font-size: 1.5rem;
          line-height: 2.4rem;
        }
      }
    }
  }
}
</style>
